/**
 * @deprecated
 *
 * Use HtmlTable instead
 *
 */

import styled from 'styled-components';
import {
  BoxShadowProps,
  compose,
  flexbox,
  FlexboxProps,
  layout,
  space,
  typography,
  variant,
  color,
} from 'styled-system';
import {
  BorderProps,
  LayoutProps,
  SpaceProps,
  TypographyProps,
  ColorProps,
} from '../../../theme/styledProps';
import { Text } from '../Text/Text';
import { Box } from '../Box/Box';

type TableVariant = 'embedded' | 'noTitle' | 'bordered';

export interface TableProps extends SpaceProps {
  variant?: TableVariant;
}

export const TableWrapper = styled.div<TableProps>`
  ${space};
  width: 100%;
  border-radius: 4px 4px 0 0;
  overflow: hidden;
  box-shadow: 0 0 4px rgba(55, 65, 81, 0.06), 0 2px 6px rgba(55, 65, 81, 0.1);

  @media print {
    box-shadow: none;
    border: 1px solid ${({ theme }) => theme.colors.neutral['200']};
  }

  ${variant<BorderProps & BoxShadowProps, TableVariant>({
    variants: {
      embedded: {
        boxShadow: 'none',
        borderRadius: 'none',
      },

      noTitle: {
        borderRadius: 'none',
      },

      bordered: {
        borderRadius: 'medium',
        boxShadow: 'none',
        border: '1px solid',
        borderColor: 'neutral.200',
      },
    },
  })}
`;

export const TableTitle = styled.div`
  background: ${({ theme }) => theme.colors.white};
  padding: 12px 16px;
`;

export const TableHeader = styled(Box)`
  background: ${({ theme }) => theme.colors.neutral[100]};

  ${Text} {
    font-weight: ${({ theme }) => theme.fontWeights[600]};
    font-size: ${({ theme }) => `${theme.fontSizes.small}px`};
    color: ${({ theme }) => theme.colors.neutral[500]};
    letter-spacing: ${({ theme }) => theme.letterSpacings.wide};
    text-transform: uppercase;
  }
`;

export const TableBody = styled(Box)`
  background: ${({ theme }) => theme.colors.white};
  overflow: auto;
`;

interface TableCellProps extends LayoutProps, TypographyProps, FlexboxProps, ColorProps {}

export const TableCell = styled.div<TableCellProps>`
  display: flex;
  align-items: center;
  padding: 0 12px;
  flex: 1 0 auto;
  box-sizing: border-box;
  ${compose(typography, layout, flexbox, color)}
`;

interface TableRowProps extends LayoutProps, SpaceProps {
  noBorder?: boolean;
}

export const TableRow = styled.div<TableRowProps>`
  display: flex;
  justify-content: space-between;
  padding: 10px 16px;
  transition: background 0.3s ease;
  border-top: ${({ theme, noBorder }) =>
    noBorder ? 'none' : `1px solid ${theme.colors.neutral[200]}`};
  ${space}
  ${compose(layout)}

  ${TableCell}:first-child {
    padding-left: 0;
  }
  ${TableCell}:last-child {
    padding-right: 0;
  }
`;

export const ClickableRow = styled(TableRow).attrs({
  tabindex: 0,
  role: 'button',
  'aria-pressed': false,
})`
  cursor: pointer;
  &:hover {
    background: ${({ theme }) => theme.colors.white};
  }
`;
